import { graphql } from '@apollo/client/react/hoc';
import productsQuery from './productsQuery.graphql';
import component from './component';

export default graphql(productsQuery, {
  props: ({ data: { saleProducts = [] } }) => ({ saleProducts })
},
)(component);
